export function getPlayerSpriteRowOffset(direction) {
  switch (direction) {
    case "up":
      return 64; // row=2
    case "right":
      return 32; // row=1
    case "down":
      return 0; // row=0
    case "left":
      return 96; // row=3
    default:
      return 0;
  }
}

export function movePlayer(
  playerPos,
  direction,
  tileSize,
  mapWidth,
  mapHeight,
) {
  let { x, y } = playerPos;
  let newDir = direction;

  switch (direction) {
    case "up":
      y -= tileSize;
      break;
    case "down":
      y += tileSize;
      break;
    case "left":
      x -= tileSize;
      break;
    case "right":
      x += tileSize;
      break;
    default:
      break;
  }

  // clamp for 32×32 character sprite
  let maxX = mapWidth - 32;
  let maxY = mapHeight - 32;
  if (x < 0) x = 0;
  if (y < 0) y = 0;
  if (x > maxX) x = maxX;
  if (y > maxY) y = maxY;

  return { x, y, direction: newDir };
}
